import {Stack} from '@mui/material';
import {ChatList} from './ChatList';
import ChatWindow from './ChatWindow';
import {useEffect} from 'react';
import {useChatContext} from '../context';

export const ChatContent = () => {
    const {setSelectedChat} = useChatContext();

    useEffect(() => {
        return () => {
            setSelectedChat(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <Stack
            width='100%'
            height='100%'
        >
            <Stack
                direction='row'
                gap={1}
                flex={1}
                minHeight={0}
            >
                <ChatList />

                <Stack
                    flex={1}
                    height='100%'
                >
                    <ChatWindow />
                </Stack>
            </Stack>
        </Stack>
    );
};
